import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { translate, Trans } from "react-i18next";
import { withRouter } from "react-router";

import Wrapper from "components/Wrapper";
import Title from "components/Title";

import InlineLink from "../../components/InlineLink";
import CheckIp from "../../components/Cgn/CheckIp";
import UpdateIp from "../../components/Cgn/UpdateIp";
import Questions from "../../components/Cgn/Questions";
import InputMacAddress from "../../components/Cgn/InputMacAddress";

import consts from "consts/consts";

import { getCgnAccess, getCgnComponent, updateCgnDeviceIpPolicy } from "actions/cgn";
import style from "./style.css";

@translate()
@withRouter
@connect((state) => ({
  isUserLoading: state.cgn.user.loading === true,
  isComponentQuizzLoading: state.cgn.component_quizz.loading === true,
  isUpdateLoading:state.cgn.update.loading === true,
  weCareID: state.session.weCareID,
  devices: (typeof state.cgn.user.data !== 'undefined' && typeof state.cgn.user.data.devices !== 'undefined') ? state.cgn.user.data.devices : [],
  quizz: (typeof state.cgn.component_quizz.data !== 'undefined') ? state.cgn.component_quizz.data : [],
}))
export default class PageCgn extends Component {
  state = {
    isModalOpened: false,
    selectedDevice: null,
    newIpPolicy: {
      success: null,
      message: null
    },
    ipPolicy: {
      success: null,
      message: null,
      canBeUpdated: false
    },
    answers: [],
  };

  constructor(data) {
    super(data);
    this.modemSerialValue = null;
  }

  componentDidMount() {
    const { weCareID } = this.props;
    if (!weCareID) {
      this.props.history.replace(consts.routes.cgn_login.url);
    }
    this.loadCgnUser();
    this.loadCgnComponent();
  }

  clearIpPolicy() {
    this.setState({
      ipPolicy: {
        success: null,
        message: null
      }
    });
  }

  clearNewIpPolicy() {
    this.setState({
      newIpPolicy: {
        success: null,
        message: null
      }
    });
  }

  loadCgnComponent() {
    const { weCareID, i18n } = this.props;
    let language = i18n.language.indexOf("nl") !== -1 ? "nl" : "fr";
    if (weCareID) {
      this.props.dispatch(getCgnComponent(weCareID, 'quizz', language));
    }
  }

  loadCgnUser() {
    const { weCareID } = this.props;
    if (weCareID) {
        this.props.dispatch(getCgnAccess(weCareID));
    }
  }

  refreshCgnUser() {
    const { weCareID } = this.props;
    this.props.dispatch(getCgnAccess(weCareID)).then(()=>{
      this.checkModemSerial();
      this.clearNewIpPolicy();
    })
  }

  getSelectedDevice() {
    const { devices } = this.props;
    if (!this.modemSerialValue.length) {
        return null;
    }
    let selectedDevice = null;
    let modemSerialValue = this.modemSerialValue;
    Array.prototype.forEach.call(devices, function (device) {
      if (selectedDevice === null && typeof device.phisicalAddress !== 'undefined' && device.phisicalAddress === modemSerialValue) {
          selectedDevice = device;
      }
    });
    return selectedDevice;
  }

  checkModemSerial() {
    const selectedDevice = this.getSelectedDevice();
    if (selectedDevice) {
      const ipPolicyStatus = typeof selectedDevice.ipPolicy !== "undefined" ? selectedDevice.ipPolicy : null;
      let ipPolicyStatusTranslatedKey = null;
      let ipPolicyStatusSuccess = null;
      switch (ipPolicyStatus) {
        case 'error':
        case 'invalid':
          ipPolicyStatusTranslatedKey = '_cgn_ip_policy_'+ipPolicyStatus;
          ipPolicyStatusSuccess = false;
          break;
        case 'cgn':
        case 'public':
          ipPolicyStatusTranslatedKey = '_cgn_ip_policy_'+ipPolicyStatus;
          ipPolicyStatusSuccess = true;
          break;
        default:
          ipPolicyStatusTranslatedKey = ipPolicyStatus;
          ipPolicyStatusSuccess = true;
          break;
      }
      this.setState({
        selectedDevice: selectedDevice,
        ipPolicy: {
          success: ipPolicyStatusSuccess,
          message: ipPolicyStatusTranslatedKey,
          canBeUpdated: ipPolicyStatus === 'cgn'
        }
      });
    } else if (this.modemSerialValue.length > 0) {
      this.setState({
        selectedDevice: null,
        ipPolicy: {
          success: false,
          message: '_cgn_ip_policy_invalid',
          canBeUpdated: false
        }
      });
    } else {
      this.setState({
        selectedDevice: null,
        ipPolicy: {
          success: null,
          message: null,
          canBeUpdated: false
        }
      });
    }
  }

  onChangeModemSerial(event) {
    this.modemSerialValue = event.target.value;
    this.checkModemSerial();
  }

  onUpdateDeviceIpPolicy() {
    const { weCareID } = this.props;
    let policy = 'optout';
    this.clearNewIpPolicy();
    this.props.dispatch(updateCgnDeviceIpPolicy(weCareID, this.state.selectedDevice.id, this.state.answers, policy)).then((response)=> {
      let success = response.status;
      let message = success === true ? response.result.message : response.error.message;
      let messageTranslatedKey = null;
      switch (message) {
        case 'error':
        case 'invalid':
        case 'success':
        case 'waiting':
          messageTranslatedKey = '_cgn_update_ip_policy_result_'+message;
          break;
        default:
          messageTranslatedKey = message;
          break;
      }
      this.setState({
        newIpPolicy: {
          success: success,
          message: messageTranslatedKey
        }
      })
    })
  }

  handleInputChange(event) {
    console.error(event);
    const target = event.target;
    const value = target.value;
    const names = target.name.split("_");
    const checked = target.type === 'checkbox' ? target.checked : true;
    const answerId = names[names.length - 1];

    let answers = this.state.answers;
    let finalAnswers = [];
    let inside = false;

    answers.forEach(function(answer) {
      if (answer.id.toString() === answerId) {
        inside = true;
        if (checked) {
          answer.answer = value;
        } else {
          answer = null;
        }
      }
    });

    if (inside === false && checked === true) {
      answers.push({
        id: answerId,
        answer: value,
      });
    }

    answers.forEach(function(answer) {
      if (answer.id.toString() === answerId) {
        if (checked && answer.answer !== '') {
          finalAnswers.push(answer);
        }
      } else {
        finalAnswers.push(answer);
      }
    });

    this.setState({
      answers: finalAnswers
    });
  }

  render() {
    const { quizz, isUpdateLoading, isUserLoading } = this.props;
    const { answers } = this.state;
    return (
      <Fragment>
        <Wrapper>
          <Title>
            <Trans>The CGN at your place.</Trans>
          </Title>
          <p>
            <Trans>_cgn_form_at_you_place_txt_p1</Trans> <InlineLink to="/cgn"><Trans>_cgn_form_at_you_place_txt_p1_link</Trans></InlineLink><Trans>_cgn_form_at_you_place_txt_p1_end</Trans>
          </p>
          <div className={style.form}>
            <p>
              <b><Trans>_cgn_form_input_your_modem_id</Trans></b>
              &nbsp;
              <InputMacAddress
                name="modemSerial"
                type="text"
                defaultValue={this.modemSerialValue || ''}
                isDisabled={isUserLoading || isUpdateLoading}
                onChange={this.onChangeModemSerial.bind(this)} />
            </p>
            <Trans>_cgn_form_check_your_modem_id_label</Trans>
            <CheckIp
              isLoading={isUserLoading}
              isDisabled={!this.state.selectedDevice}
              onClick={this.refreshCgnUser.bind(this)}
              ipPolicy={this.state.ipPolicy}/>
            <Trans>_cgn_form_ask_ip_public_address_reasons_label</Trans>
            <Questions
              isDisabled={!this.state.selectedDevice || this.state.ipPolicy.canBeUpdated === false}
              questions={quizz}
              answers={answers}
              onChange={this.handleInputChange.bind(this)}/>
            <UpdateIp
              isLoading={isUpdateLoading}
              isDisabled={!this.state.selectedDevice || this.state.newIpPolicy.success !== null || answers.length === 0 || this.state.ipPolicy.canBeUpdated === false}
              newIpPolicy={this.state.newIpPolicy}
              onClick={this.onUpdateDeviceIpPolicy.bind(this)}/>
          </div>
        </Wrapper>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PageCgn/index.js